// Action emitted by angular should have their type prefixed.
const ANGULAR_ACTION_PREFIX = '__angular__';

export { ANGULAR_ACTION_PREFIX };
